import { PitcherAgeBand } from './softball.enums';

/**
 * Windmill-pitch rest guidelines for fastpitch softball. Values reflect
 * common league guidance (USA Softball / NFHS) for daily maxima and rest.
 * The shape mirrors baseball's pitch-smart-rules so the engines compose.
 */
export const WINDMILL_DAILY_MAX: Record<PitcherAgeBand, number> = {
  [PitcherAgeBand.Age7_8]: 60,
  [PitcherAgeBand.Age9_10]: 90,
  [PitcherAgeBand.Age11_12]: 110,
  [PitcherAgeBand.Age13_14]: 125,
  [PitcherAgeBand.Age15_16]: 140,
  [PitcherAgeBand.Age17_18]: 150,
  [PitcherAgeBand.Age19_22]: 165
};

export interface RestRule {
  pitches: number;
  restDays: number;
}

export const WINDMILL_REST: Record<PitcherAgeBand, readonly RestRule[]> = {
  [PitcherAgeBand.Age7_8]: [
    { pitches: 30, restDays: 0 },
    { pitches: 45, restDays: 1 },
    { pitches: 60, restDays: 2 }
  ],
  [PitcherAgeBand.Age9_10]: [
    { pitches: 30, restDays: 0 },
    { pitches: 50, restDays: 1 },
    { pitches: 70, restDays: 2 },
    { pitches: 90, restDays: 3 }
  ],
  [PitcherAgeBand.Age11_12]: [
    { pitches: 35, restDays: 0 },
    { pitches: 60, restDays: 1 },
    { pitches: 85, restDays: 2 },
    { pitches: 110, restDays: 3 }
  ],
  [PitcherAgeBand.Age13_14]: [
    { pitches: 40, restDays: 0 },
    { pitches: 65, restDays: 1 },
    { pitches: 90, restDays: 2 },
    { pitches: 125, restDays: 3 }
  ],
  [PitcherAgeBand.Age15_16]: [
    { pitches: 50, restDays: 0 },
    { pitches: 75, restDays: 1 },
    { pitches: 100, restDays: 2 },
    { pitches: 140, restDays: 3 }
  ],
  [PitcherAgeBand.Age17_18]: [
    { pitches: 50, restDays: 0 },
    { pitches: 80, restDays: 1 },
    { pitches: 110, restDays: 2 },
    { pitches: 150, restDays: 3 }
  ],
  [PitcherAgeBand.Age19_22]: [
    { pitches: 55, restDays: 0 },
    { pitches: 85, restDays: 1 },
    { pitches: 120, restDays: 2 },
    { pitches: 165, restDays: 3 }
  ]
};

export function requiredRestDays(ageBand: PitcherAgeBand, pitchCount: number): number {
  if (pitchCount <= 0) return 0;
  const ladder = WINDMILL_REST[ageBand];
  for (const rule of ladder) {
    if (pitchCount <= rule.pitches) return rule.restDays;
  }
  return ladder[ladder.length - 1].restDays;
}

export function ageToBand(age: number): PitcherAgeBand {
  if (age <= 8) return PitcherAgeBand.Age7_8;
  if (age <= 10) return PitcherAgeBand.Age9_10;
  if (age <= 12) return PitcherAgeBand.Age11_12;
  if (age <= 14) return PitcherAgeBand.Age13_14;
  if (age <= 16) return PitcherAgeBand.Age15_16;
  if (age <= 18) return PitcherAgeBand.Age17_18;
  return PitcherAgeBand.Age19_22;
}
